import React from "react"
import PropTypes from "prop-types"
import styled, { css } from "styled-components"
import { breakpoints } from "../../../theme"

const TitleWrapper = styled.div`
  color: var(--font-color);
  margin-bottom: ${props => (props.size === "h4" ? "0" : "25px")};

  .level {
    margin: 0;
    ${props =>
      props.$inline &&
      `
    display: flex;
    flex-wrap: wrap;
      `}

    > :first-child {
      margin-right: 0.25em;
    }
  }
`

const Flex = styled.div`
  display: flex;
  align-items: end;
  > :nth-child(2) {
    margin-right: 7px;
  }
`

const styleTitle = css`
  font-family: "Ginto", georgia, serif;
  font-weight: 300;
  display: flex;
  align-items: end;
  font-size: ${props =>
    props.size === "h1"
      ? "37px"
      : props.size === "h1small"
      ? "28px"
      : props.size === "h2"
      ? "24px"
      : props.size === "h3"
      ? "20px"
      : props.size === "h4"
      ? "17px"
      : "15px"};
  line-height: 1.15;
  margin: 0;

  @media (min-width: ${breakpoints.small}px) {
    font-size: ${props =>
      props.size === "h1"
        ? "45px"
        : props.size === "h1small"
        ? "35px"
        : props.size === "h2"
        ? "32px"
        : props.size === "h3"
        ? "28px"
        : props.size === "h4"
        ? "17px"
        : "15px"};
  }
  @media (min-width: ${breakpoints.medium}px) {
    font-size: ${props =>
      props.size === "h1"
        ? "65px"
        : props.size === "h1small"
        ? "35px"
        : props.size === "h2"
        ? "32px"
        : props.size === "h3"
        ? "28px"
        : props.size === "h4"
        ? "17px"
        : "15px"};
  }

  @media (min-width: ${breakpoints.large}px) {
    font-size: ${props =>
      props.size === "h1"
        ? "82px"
        : props.size === "h1small"
        ? "35px"
        : props.size === "h2"
        ? "32px"
        : props.size === "h3"
        ? "28px"
        : props.size === "h4"
        ? "17px"
        : "15px"};
  }
`

const Suptitle = styled.div`
  ${styleTitle}
`

const MainTitle = styled.div`
  ${styleTitle}
  font-weight: 500;
`

const Subtitle = styled.div`
  margin-top: 1em;
  font-style: 500;
  font-weight: 400;
  font-size: 18px;
  line-height: 152.9%;
`

const Title = ({ suptitle, title, subtitle, level, inline = true, size }) => {
  const TitleLevel = level === "div" ? "div" : `h${level}`
  return (
    <TitleWrapper $inline={inline} className="title">
      <Flex>
        <TitleLevel className="level">
          {suptitle && <Suptitle size={size}>{suptitle} </Suptitle>}
          <MainTitle size={size}>{title}</MainTitle>
        </TitleLevel>
      </Flex>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
    </TitleWrapper>
  )
}

Title.propTypes = {
  suptitle: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  size: PropTypes.oneOf(["h1", "h1small", "h2", "h3", "h4", "h5"]),
  level: PropTypes.oneOf([1, 2, 3, 4, 5, "div"]),
}

Title.defaultProps = {
  size: "h2",
  level: 2,
}

export { Title }
